if ( typeof JKLProductPoints !== 'function' ) {
    class JKLProductPoints extends HTMLElement {
        constructor() {
            super();

            this.id = this.dataset.id;
            this.points = parseInt(this.dataset.points ?? '0');

            this.pointsEl = this.querySelector('.points');
            this.variantPicker = document.querySelector(`product-variants[data-id="${this.id}"]`);

            if ( !this.variantPicker ) {
                return;
            }

            this.variantPicker.addEventListener('jkl:variant-change', e => {
                const variant = e?.detail?.variant;
                this.variant = variant;
                this.onVariantChange();
            });
        }

        async onVariantChange() {
            if ( !this.variant ) {
                this.points = 0;
                this.setAttribute('data-points', this.points);
                return;
            }
            
            try {
                await this.getPoints();
                this.updatePoints();
            } catch (err) {
                console.error(err);
            } finally {
                this.setAttribute('data-points', this.points);
            }
        }

        async getPoints() {
            const { pathname } = new URL(window.location.href);
            const url = `${pathname}?variant=${this.variant.id}&view=jkl-product-points`;

            const response = await fetch(url);

            if ( !response.ok ) {
                console.error('Network error');
            }

            const json = await response.text();

            const { points } = JSON.parse(json || '{}');

            this.points = points ?? 0;

        }

        updatePoints() {
            this.pointsEl.textContent = this.points;
        }
    }

    customElements.define('jkl-product-points', JKLProductPoints);
}